import { render, staticRenderFns } from "./Redemption.vue?vue&type=template&id=b9465268"
import script from "./Redemption.vue?vue&type=script&lang=js"
export * from "./Redemption.vue?vue&type=script&lang=js"
import style0 from "./Redemption.vue?vue&type=style&index=0&id=b9465268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports